// @flow
import Big from "big.js";

import type { Theme, UtilThemeProps } from "../types";
import IllegalArgumentException from "../../exceptions/IllegalArgumentException";
import IllegalStateException from "../../exceptions/IllegalStateException";

/**
 */
const getSize = (
  theme: Theme,
  ratio: number | string = 1,
  path: string = "SPACER",
  unit: string = "rem",
) => {
  if (typeof ratio === "string") {
    return ratio;
  }

  if (typeof ratio === "number") {
    if (typeof theme[path] === "number") {
      const size = Big(ratio).times(theme[path]);
      return `${size}${unit}`;
    }
    throw new IllegalStateException(`Size ${path} must be a number`);
  }

  throw new IllegalArgumentException(
    `Ratio ${JSON.stringify(ratio)} must be a string or number`,
  );
};

/*
 * Render spacers based on the given ratio * theme SPACER
 */
/**
 */
const spacer =
  (ratio: number = 1): ((UtilThemeProps) => string) =>
  ({ theme = { settings: {} } }: UtilThemeProps) =>
    getSize(theme, ratio);

/*
 * Render spacers based on the given ratio * theme SPACER
 * Ratio's can be given clockwise with shorthand,
 * spacers(0.5, 1) with a spacer of 0.8 will give "0.4rem 1rem";
 */
/**
 */
const spacers =
  (...ratios: Array<number | "auto">): ((UtilThemeProps) => string) =>
  ({ theme = { settings: {} } }: UtilThemeProps) =>
    ratios.map((ratio) => getSize(theme, ratio)).join(" ");

/*
 * Render a gutter based on GUTTER property
 */
/**
 */
const gutter =
  (ratio: number = 1): ((UtilThemeProps) => string) =>
  ({ theme = { settings: {} } }: UtilThemeProps) =>
    getSize(theme, ratio, "GRID_GUTTER", "px");

export { spacer, spacers, gutter };
